<template>
  <v-card
    height="500"
    img="https://cdn.discordapp.com/attachments/541925080536449034/751948030139433091/unknown.png"
  >
    <div class="headline-text">
      <v-row class="pa-3 justify-center">
        <p class="white--text font-weight-bold" style="font-size:11vw">BDO TRACKER</p>
      </v-row>
    </div>
    <div class="searchbar">
      <v-row class="pa-3 justify-center">
        <v-col cols="10">
          <v-btn-toggle v-model="charFamilyToggle" mandatory class="d-flex">
            <v-col cols="6" class="ma-0 pa-0">
              <v-btn
                height="50"
                block
                class="rounded-r-0"
                style="border-style: none;"
                dark
                color="rgba(15,15,15,1)"
              >Char</v-btn>
            </v-col>
            <v-col cols="6" class="ma-0 pa-0">
              <v-btn
                height="50"
                block
                class="rounded-l-0"
                style="border-style: none;"
                dark
                color="rgba(15,15,15,1)"
              >Family</v-btn>
            </v-col>
          </v-btn-toggle>
          <v-text-field
            placeholder="Search for Player.."
            solo
            class="rounded-t-0"
            height="50"
            autofocus
            dense
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "SearchbarDesktop",
  data() {
    return {
      charFamilyToggle: 0
    };
  }
};
</script>

<style scoped>
</style>